import React from 'react';
import styled from 'styled-components';
import { FaGithub, FaLinkedin, FaEnvelope, FaHeart } from 'react-icons/fa';
import { CONTACT_INFO } from '../constants/contact';

const FooterContainer = styled.footer`
  background: rgba(0, 0, 0, 0.8);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 3rem 0 1rem;
  margin-top: 2rem;
  position: relative;
  z-index: 1;
  width: 100%;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FooterSection = styled.div``;

const FooterTitle = styled.h3`
  color: #00d4ff;
  font-size: 1.2rem;
  margin-bottom: 1rem;
`;

const FooterText = styled.p`
  color: #cccccc;
  line-height: 1.6;
  margin-bottom: 0.5rem;
`;

const FooterLink = styled.a`
  color: #cccccc;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #00d4ff;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #00d4ff;
  border-radius: 50%;
  color: #00d4ff;
  font-size: 1rem;
  transition: all 0.3s ease;
  
  &:hover {
    background: #00d4ff;
    color: #0a0a0a;
    transform: translateY(-2px);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Copyright = styled.p`
  color: #999999;
  font-size: 0.9rem;
`;

const MadeWith = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #999999;
  font-size: 0.9rem;
`;

const HeartIcon = styled(FaHeart)`
  color: #ff6b6b;
  animation: heartbeat 1.5s ease-in-out infinite;
  
  @keyframes heartbeat {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <FooterSection>
            <FooterTitle>About</FooterTitle>
            <FooterText>
              풀스택 개발자로서 사용자 중심의 웹 애플리케이션을 개발하는 것을 좋아합니다.
              새로운 기술을 배우고 적용하는 것에 열정을 가지고 있습니다.
            </FooterText>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Quick Links</FooterTitle>
            <FooterText>
              <FooterLink href="#about">소개</FooterLink>
            </FooterText>
            <FooterText>
              <FooterLink href="#skills">기술</FooterLink>
            </FooterText>
            <FooterText>
              <FooterLink href="#projects">프로젝트</FooterLink>
            </FooterText>
            <FooterText>
              <FooterLink href="#certifications">자격증</FooterLink>
            </FooterText>
            <FooterText>
              <FooterLink href="#contact">연락처</FooterLink>
            </FooterText>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Contact Info</FooterTitle>
            <FooterText>Email: {CONTACT_INFO.EMAIL}</FooterText>
            <FooterText>Phone: {CONTACT_INFO.PHONE}</FooterText>
            <FooterText>Location: {CONTACT_INFO.LOCATION}</FooterText>
            
            <SocialLinks>
              <SocialLink href={CONTACT_INFO.GITHUB} target="_blank" rel="noopener noreferrer">
                <FaGithub />
              </SocialLink>
              <SocialLink href={CONTACT_INFO.LINKEDIN} target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </SocialLink>
              <SocialLink href={`mailto:${CONTACT_INFO.EMAIL}`}>
                <FaEnvelope />
              </SocialLink>
            </SocialLinks>
          </FooterSection>
        </FooterTop>
        
        <FooterBottom>
          <Copyright>
            © {currentYear} [김수빈]. All rights reserved.
          </Copyright>
          <MadeWith>
            Made with <HeartIcon /> by React & TypeScript
          </MadeWith>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 
